import { RequestProvider } from '@/shared/providers/request.provider';

class loadZipGeoCoords {

  public verifyZipCode(zipcode: number) {
    return RequestProvider.requestPublic('GET', `address/zipGeocoords?zipCode=${zipcode}`);
  }
}

export const ZipCodeService = new loadZipGeoCoords();